<template>
  <v-layout>
    <v-progress-linear
      v-show="loading"
      style="position: absolute; z-index: 10"
      :indeterminate="true"
      class="ma-0"
    />
    <v-flex xs6 style="max-height: calc(100vh - 100px); overflow-y: auto">
      <v-layout column justify-center pa-4>
        <div class="title text-xs-center pb-4">Ločeni dokumenti</div>
        <v-flex v-if="!separatedDocuments.length" xs12 class="text-xs-center subheading">
          Trenutno ni ločenih še nobenih dokumentov.
        </v-flex>
        <v-flex v-for="(document, index) in separatedDocuments" :key="index" xs12 class="py-2">
          <v-card>
            <v-card-title style="font-size: 18px">
              <v-layout row wrap align-center justify-space-between>
                <v-flex xs6>
                  <span>Št. ločenega dokumenta: {{ index + 1 }}</span>
                </v-flex>
                <v-flex xs3 style="display: flex; flex-direction: column; align-items: center">
                  <span class="font-weight-medium text--primary"> Prva stran: </span>
                  <v-select
                    v-model="document.first"
                    style="width: 50%"
                    :items="pageList"
                    type="number"
                    @change="changeDocumentPages(document)"
                  />
                </v-flex>
                <v-flex xs3 style="display: flex; flex-direction: column; align-items: center">
                  <span class="font-weight-medium"> Zadnja stran: </span>
                  <v-select
                    v-model="document.last"
                    style="width: 50%"
                    :items="generatePageListForDocument(document.first, numPages)"
                    type="number"
                  />
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-actions>
              <v-spacer />
              <v-btn color="red" flat @click="deleteDocument(index)"> Izbriši dokument </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <template v-if="attachmentToSplit">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                id="confirm_documents"
                fab
                dark
                fixed
                style="right: 100px; bottom: 48px"
                bottom
                color="green"
                v-on="on"
                @click="splitFile"
              >
                <v-icon>send</v-icon>
              </v-btn>
            </template>
            <span>Pošlji ločene dokumente v obdelavo</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                id="clear_documents"
                fab
                dark
                fixed
                right
                style="bottom: 48px"
                color="red"
                v-on="on"
                @click="clearDocumentDialog = true"
              >
                <v-icon>clear</v-icon>
              </v-btn>
            </template>
            <span>Zavrži trenutne dokument</span>
          </v-tooltip>
        </template>
      </v-layout>
    </v-flex>
    <v-flex xs6 style="border-right: solid 1px #eee">
      <pdf-splitter
        :attachment="attachmentToSplit"
        :selected-page-number="selectedPageNumber"
        :split-document="currentDocument"
        @page-num="pageNumber = $event"
        @num-pages="numPages = $event"
      />
    </v-flex>
    <VDialog v-model="clearDocumentDialog" persistent max-width="290">
      <VCard>
        <VCardTitle class="headline"> Želite zavreči dokumente? </VCardTitle>
        <VCardText>
          Vsi trenutno ločeni dokumenti bodo zavrženi, ponovno boste morali ločiti dokumente v
          računu.
        </VCardText>
        <VCardActions>
          <VSpacer />
          <VBtn color="teal darken-1" flat @click.native="clearDocumentDialog = false">
            Prekliči
          </VBtn>
          <VBtn color="teal darken-1" flat @click.native="clearFile"> Zavrži </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
    <VDialog v-model="confirmDialog" persistent width="max-content">
      <ConfirmSplitting
        :separated-documents="separatedDocumentsWithData"
        :attachment="attachment"
        @clearDocument="clearFile"
        @uploadingFinished="closeDialog"
        @close-dialog="closeDialog"
      />
    </VDialog>
  </v-layout>
</template>

<script>
import { range } from 'lodash';
import { mapGetters } from 'vuex';
import { axiosInstance, downloadFile } from '../services/api';
import PdfSplitter from '../components/pdf_splitter/PdfSplitter.vue';
import ConfirmSplitting from '../components/pdf_splitter/ConfirmSplitting.vue';

export default {
  name: 'Splitting',
  components: {
    ConfirmSplitting,
    PdfSplitter,
  },
  data() {
    return {
      fileName: '',
      pageNumber: 1,
      numPages: null,
      selectedPageNumber: 0,
      loading: false,
      clearDocumentDialog: false,
      currentDocument: {
        first: 1,
        last: null,
      },
      confirmDialog: false,
      separatedDocumentsWithData: [],
      attachment: null,
      attachmentToSplit: null,
    };
  },
  mounted() {
    this.$store.dispatch('setDrawerStateAction', true);
  },
  computed: {
    ...mapGetters(['separatedDocuments', 'splittedAttachment']),
    pageList() {
      return range(1, this.numPages + 1);
    },
  },
  watch: {
    splittedAttachment: {
      handler(value) {
        if (value) {
          this.attachmentToSplit = value;
          this.fileName = value.file_name;
        }
        this.selectedPageNumber = 0;
      },
      immediate: true,
    },
  },
  destroyed() {
    this.clearFile();
  },
  methods: {
    generatePageListForDocument(firstPage, lastPage) {
      return range(firstPage, lastPage + 1);
    },
    changeDocumentPages(document) {
      if (document.first > document.last) {
        // eslint-disable-next-line no-param-reassign
        document.last = document.first;
      }
    },
    clearFile() {
      this.$store.dispatch('deleteAllDocuments');
      this.$store.dispatch('selectAttachment', null);
      this.fileName = null;
      this.clearDocumentDialog = false;
      this.selectedPageNumber = 0;
      this.attachment = null;
      this.attachmentToSplit = null;
    },
    deleteDocument(index) {
      const document = this.separatedDocuments[index - 1];
      if (document) {
        this.currentDocument = {
          first: document.last === this.numPages ? document.last : document.last + 1,
          last: null,
        };
        this.selectedPageNumber =
          document.last === this.numPages ? document.last : document.last + 1;
      } else {
        this.currentDocument = {
          first: 1,
          last: null,
        };
        this.selectedPageNumber = 2;
      }
      this.$store.dispatch('deleteDocumentAtIndex', index);
    },
    async getAttachment() {
      const { data } = await axiosInstance.get(this.splittedAttachment.url);
      this.attachment = data;
      return data;
    },
    async splitFile() {
      try {
        this.loading = true;
        const fileName = this.fileName.split('.').slice(0, -1).join('.');
        const extension = this.fileName.split('.').pop();

        const attachment = await this.getAttachment();
        if (attachment.status === 'SP') {
          this.$store.dispatch('setSnackBarStateAction', {
            snackBar: true,
            color: 'info',
            text: 'Priponka je že bila razdeljena. Osvežite seznam.',
          });
          this.loading = false;
          return;
        }

        if (this.separatedDocuments.length === 1) {
          const { data } = await downloadFile(this.attachmentToSplit.file);
          const separatedDocumentWithData = {
            file: new Uint8Array(data),
            fileName: `${fileName}.${extension}`,
            fileNameShort: `${fileName.substr(0, 90)}.${extension}`,
            fromPage: this.separatedDocuments[0].first,
            toPage: this.separatedDocuments[0].last,
          };
          this.separatedDocumentsWithData = [separatedDocumentWithData];
          this.confirmDialog = true;
        } else {
          const separatedDocuments = await this.$store.dispatch('createPdfObjects', {
            pdfFile: this.attachmentToSplit.file,
          });
          let numberOfUploadedPages = 0;
          for (let index = 0; index < separatedDocuments.length; index += 1) {
            // eslint-disable-next-line no-await-in-loop
            const file = await separatedDocuments[index].save();
            numberOfUploadedPages += separatedDocuments[index].getPageCount();
            separatedDocuments[index].fileNameShort = `${fileName.substr(
              0,
              90
            )}_${index}.${extension}`;
            separatedDocuments[index].fileName = `${fileName}_${index}.${extension}`;
            separatedDocuments[index].file = file;
            separatedDocuments[index].fromPage = this.separatedDocuments[index].first;
            separatedDocuments[index].toPage = this.separatedDocuments[index].last;
          }
          if (numberOfUploadedPages !== this.numPages) {
            throw new Error(
              'Seštevek števila ločenih strani se ne ujema s številom strani originalnega dokumenta!'
            );
          }

          this.separatedDocumentsWithData = separatedDocuments;
          this.confirmDialog = true;
        }
      } catch (err) {
        this.$store.dispatch('setSnackBarStateAction', {
          snackBar: true,
          color: 'red',
          text: err.message,
        });
        this.confirmDialog = false;
      }
      this.loading = false;
    },
    closeDialog() {
      this.confirmDialog = false;
    },
  },
};
</script>
